/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import {useTranslation} from "react-i18next";
import {PackageCategoryPriceImage} from "types/entities/PackageCategoryEntity";

const CategoryDetailPricesImages = (props: {priceImages: PackageCategoryPriceImage[]}) => {
    const {t} = useTranslation();
    return (
        <section className={"CategoryDetailPricesImages col-span-12 flex justify-center"}>
            <div className={"flex flex-col md:flex-row w-full max-w-3xl gap-x-4 md:gap-x-6 lg:gap-x-8 xl:gap-x-12 gap-y-4 md:gap-y-6 lg:gap-y-8 xl:gap-y-12"}>
                {props.priceImages.map((priceImage, index) => {
                    return (
                        <picture key={index} className={"rounded-2xl overflow-hidden"}>
                            <img src={priceImage.image} alt={priceImage.alt} />
                        </picture>
                    );
                })}
            </div>
        </section>
    );
};

export default CategoryDetailPricesImages;
